import React, { useEffect, useState } from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

export default function WriteInventory(props) {
  const { inputChange, dataProduct } = props; //data Products

  const [measureUnitTypes, setMeasureUnitTypes] = useState([]);

  async function listMeasureUnitTypes() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setMeasureUnitTypes(response.data);
  }

  useEffect(() => {
    listMeasureUnitTypes();
  }, []);

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 style={{ color: 'black' }}>Datos</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Fijar cta de mayor según</InputLabel>
                <Select
                  value={dataProduct.GLMethod || ''}
                  inputProps={{
                    name: 'GLMethod',
                    onChange: inputChange
                  }}
                >
                  <MenuItem value="C">Grupo de artículos</MenuItem>
                  <MenuItem value="W">Almacén</MenuItem>
                  <MenuItem value="L">Nivel artículo</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Método de valorización</InputLabel>
                <Select
                  value={dataProduct.EvalSystem || ''}
                  inputProps={{
                    name: 'EvalSystem',
                    onChange: inputChange
                  }}
                >
                  <MenuItem value="A">Promedio ponderado</MenuItem>
                  <MenuItem value="S">Estándar</MenuItem>
                  <MenuItem value="F">Fijo</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Unid. medida</InputLabel>
                <Select
                  value={dataProduct.Invntryuom || ''}
                  inputProps={{
                    name: 'Invntryuom',
                    onChange: inputChange
                  }}
                >
                  {measureUnitTypes.map((item) => (
                    <MenuItem key={item.id} value={item.UgpCode}>
                      {item.UgpName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Inventariable</InputLabel>
                <Select
                  value={dataProduct.InvntItem || ''}
                  inputProps={{
                    name: 'InvntItem',
                    onChange: inputChange
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Stock x almacén</InputLabel>
                <Select
                  value={dataProduct.Bywh || ''}
                  inputProps={{
                    name: 'Bywh',
                    onChange: inputChange
                  }}
                >
                  <MenuItem value="Y">Si</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
  );
}
